import { debounce } from 'lodash'
import { useCallback } from 'react'

export const useDebounce = (value: any, delay: number) => useCallback(debounce<typeof value>(value, delay), [])
